<template>
  <el-input
    type="textarea"
    :rows="rows"
    :resize="resize"
    :readonly="readonly"
    :placeholder="placeholder"
    :modelValue="modelValue"
    :size="size"
    @update:modelValue="update($event)"
    v-if="isEdit"
    :disabled="disabled"
  />
  <jr-input-view v-else :size="size">{{ modelValue }}</jr-input-view>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import JrInputView from '@/components/jr-parts/JrInputView.vue'

export default defineComponent({
  name: 'JrTextarea',
  emits: ['update:modelValue'],
  components: { JrInputView },
  props: {
    modelValue: {
      type: String,
      required: false,
      default: null,
    },
    rows: {
      type: Number,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: null,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    resize: {
      type: String,
      required: false,
      default: 'none',
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, context) {
    return {
      update: (event: string) => {
        context.emit('update:modelValue', event)
      },
    }
  },
})
</script>
